var city = {
  "citycode": [],
  "adcode": "330000",
  "name": "浙江省",
  "center": {
      "lng": 120.152575,
      "lat": 30.266619
  },
  "districtList": [
      {
          "citycode": "0580",
          "adcode": "330900",
          "name": "舟山市",
          "center": {
              "lng": 122.207395,
              "lat": 29.985578
          },
          "districtList": [
              {
                  "citycode": "0580",
                  "adcode": "330922",
                  "name": "嵊泗县",
                  "center": {
                      "lng": 122.45132,
                      "lat": 30.725677
                  }
              },
              {
                  "citycode": "0580",
                  "adcode": "330921",
                  "name": "岱山县",
                  "center": {
                      "lng": 122.225718,
                      "lat": 30.264533
                  }
              },
              {
                  "citycode": "0580",
                  "adcode": "330902",
                  "name": "定海区",
                  "center": {
                      "lng": 122.106844,
                      "lat": 30.019795
                  }
              },
              {
                  "citycode": "0580",
                  "adcode": "330903",
                  "name": "普陀区",
                  "center": {
                      "lng": 122.323297,
                      "lat": 29.970571
                  }
              }
          ]
      },
      {
          "citycode": "0573",
          "adcode": "330400",
          "name": "嘉兴市",
          "center": {
              "lng": 120.755623,
              "lat": 30.746814
          },
          "districtList": [
              {
                  "citycode": "0573",
                  "adcode": "330482",
                  "name": "平湖市",
                  "center": {
                      "lng": 121.015619,
                      "lat": 30.677804
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330411",
                  "name": "秀洲区",
                  "center": {
                      "lng": 120.709047,
                      "lat": 30.764811
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330481",
                  "name": "海宁市",
                  "center": {
                      "lng": 120.680224,
                      "lat": 30.511536
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330424",
                  "name": "海盐县",
                  "center": {
                      "lng": 120.94628,
                      "lat": 30.52664
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330402",
                  "name": "南湖区",
                  "center": {
                      "lng": 120.782952,
                      "lat": 30.747738
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330421",
                  "name": "嘉善县",
                  "center": {
                      "lng": 120.926031,
                      "lat": 30.83085
                  }
              },
              {
                  "citycode": "0573",
                  "adcode": "330483",
                  "name": "桐乡市",
                  "center": {
                      "lng": 120.565127,
                      "lat": 30.630375
                  }
              }
          ]
      },
      {
          "citycode": "0574",
          "adcode": "330200",
          "name": "宁波市",
          "center": {
              "lng": 121.62454,
              "lat": 29.860258
          },
          "districtList": [
              {
                  "citycode": "0574",
                  "adcode": "330206",
                  "name": "北仑区",
                  "center": {
                      "lng": 121.844601,
                      "lat": 29.899548
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330225",
                  "name": "象山县",
                  "center": {
                      "lng": 121.869251,
                      "lat": 29.476826
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330211",
                  "name": "镇海区",
                  "center": {
                      "lng": 121.596686,
                      "lat": 29.965212
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330205",
                  "name": "江北区",
                  "center": {
                      "lng": 121.555067,
                      "lat": 29.88673
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330203",
                  "name": "海曙区",
                  "center": {
                      "lng": 121.550485,
                      "lat": 29.873705
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330212",
                  "name": "鄞州区",
                  "center": {
                      "lng": 121.546617,
                      "lat": 29.817302
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330213",
                  "name": "奉化区",
                  "center": {
                      "lng": 121.406151,
                      "lat": 29.655292
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330282",
                  "name": "慈溪市",
                  "center": {
                      "lng": 121.266525,
                      "lat": 30.170695
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330226",
                  "name": "宁海县",
                  "center": {
                      "lng": 121.429729,
                      "lat": 29.287929
                  }
              },
              {
                  "citycode": "0574",
                  "adcode": "330281",
                  "name": "余姚市",
                  "center": {
                      "lng": 121.154572,
                      "lat": 30.037967
                  }
              }
          ]
      },
      {
          "citycode": "0576",
          "adcode": "331000",
          "name": "台州市",
          "center": {
              "lng": 121.42079,
              "lat": 28.655716
          },
          "districtList": [
              {
                  "citycode": "0576",
                  "adcode": "331082",
                  "name": "临海市",
                  "center": {
                      "lng": 121.144625,
                      "lat": 28.859042
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331002",
                  "name": "椒江区",
                  "center": {
                      "lng": 121.442859,
                      "lat": 28.673334
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331004",
                  "name": "路桥区",
                  "center": {
                      "lng": 121.337874,
                      "lat": 28.578244
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331083",
                  "name": "玉环市",
                  "center": {
                      "lng": 121.231915,
                      "lat": 28.136703
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331081",
                  "name": "温岭市",
                  "center": {
                      "lng": 121.385435,
                      "lat": 28.372805
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331022",
                  "name": "三门县",
                  "center": {
                      "lng": 121.39561,
                      "lat": 29.104888
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331024",
                  "name": "仙居县",
                  "center": {
                      "lng": 120.728733,
                      "lat": 28.846856
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331023",
                  "name": "天台县",
                  "center": {
                      "lng": 121.006657,
                      "lat": 29.144594
                  }
              },
              {
                  "citycode": "0576",
                  "adcode": "331003",
                  "name": "黄岩区",
                  "center": {
                      "lng": 121.261804,
                      "lat": 28.649433
                  }
              }
          ]
      },
      {
          "citycode": "0577",
          "adcode": "330300",
          "name": "温州市",
          "center": {
              "lng": 120.699279,
              "lat": 27.993849
          },
          "districtList": [
              {
                  "citycode": "0577",
                  "adcode": "330305",
                  "name": "洞头区",
                  "center": {
                      "lng": 121.157406,
                      "lat": 27.836412
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330327",
                  "name": "苍南县",
                  "center": {
                      "lng": 120.425957,
                      "lat": 27.518636
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330326",
                  "name": "平阳县",
                  "center": {
                      "lng": 120.565161,
                      "lat": 27.662394
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330329",
                  "name": "泰顺县",
                  "center": {
                      "lng": 119.717643,
                      "lat": 27.556578
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330381",
                  "name": "瑞安市",
                  "center": {
                      "lng": 120.655245,
                      "lat": 27.778967
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330328",
                  "name": "文成县",
                  "center": {
                      "lng": 120.090929,
                      "lat": 27.786856
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330383",
                  "name": "龙港市",
                  "center": {
                      "lng": 120.552952,
                      "lat": 27.578379
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330324",
                  "name": "永嘉县",
                  "center": {
                      "lng": 120.69136,
                      "lat": 28.153914
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330382",
                  "name": "乐清市",
                  "center": {
                      "lng": 120.986297,
                      "lat": 28.112519
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330302",
                  "name": "鹿城区",
                  "center": {
                      "lng": 120.655199,
                      "lat": 28.015776
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330304",
                  "name": "瓯海区",
                  "center": {
                      "lng": 120.615149,
                      "lat": 27.967445
                  }
              },
              {
                  "citycode": "0577",
                  "adcode": "330303",
                  "name": "龙湾区",
                  "center": {
                      "lng": 120.812333,
                      "lat": 27.933261
                  }
              }
          ]
      },
      {
          "citycode": "0579",
          "adcode": "330700",
          "name": "金华市",
          "center": {
              "lng": 119.647265,
              "lat": 29.079195
          },
          "districtList": [
              {
                  "citycode": "0579",
                  "adcode": "330784",
                  "name": "永康市",
                  "center": {
                      "lng": 120.047356,
                      "lat": 28.88899
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330723",
                  "name": "武义县",
                  "center": {
                      "lng": 119.816341,
                      "lat": 28.892562
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330782",
                  "name": "义乌市",
                  "center": {
                      "lng": 120.075679,
                      "lat": 29.306296
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330703",
                  "name": "金东区",
                  "center": {
                      "lng": 119.692821,
                      "lat": 29.099822
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330702",
                  "name": "婺城区",
                  "center": {
                      "lng": 119.571574,
                      "lat": 29.087311
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330783",
                  "name": "东阳市",
                  "center": {
                      "lng": 120.24179,
                      "lat": 29.290158
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330727",
                  "name": "磐安县",
                  "center": {
                      "lng": 120.449937,
                      "lat": 29.054491
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330726",
                  "name": "浦江县",
                  "center": {
                      "lng": 119.89259,
                      "lat": 29.453363
                  }
              },
              {
                  "citycode": "0579",
                  "adcode": "330781",
                  "name": "兰溪市",
                  "center": {
                      "lng": 119.460404,
                      "lat": 29.209059
                  }
              }
          ]
      },
      {
          "citycode": "0571",
          "adcode": "330100",
          "name": "杭州市",
          "center": {
              "lng": 120.210792,
              "lat": 30.246026
          },
          "districtList": [
              {
                  "citycode": "0571",
                  "adcode": "330122",
                  "name": "桐庐县",
                  "center": {
                      "lng": 119.691755,
                      "lat": 29.79418
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330111",
                  "name": "富阳区",
                  "center": {
                      "lng": 119.96022,
                      "lat": 30.048803
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330102",
                  "name": "上城区",
                  "center": {
                      "lng": 120.19732,
                      "lat": 30.226543
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330114",
                  "name": "钱塘区",
                  "center": {
                      "lng": 120.493941,
                      "lat": 30.32304
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330182",
                  "name": "建德市",
                  "center": {
                      "lng": 119.281195,
                      "lat": 29.474964
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330113",
                  "name": "临平区",
                  "center": {
                      "lng": 120.299222,
                      "lat": 30.419154
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330127",
                  "name": "淳安县",
                  "center": {
                      "lng": 119.042015,
                      "lat": 29.609678
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330112",
                  "name": "临安区",
                  "center": {
                      "lng": 119.724457,
                      "lat": 30.234375
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330110",
                  "name": "余杭区",
                  "center": {
                      "lng": 119.978742,
                      "lat": 30.273705
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330106",
                  "name": "西湖区",
                  "center": {
                      "lng": 120.130396,
                      "lat": 30.259242
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330105",
                  "name": "拱墅区",
                  "center": {
                      "lng": 120.141503,
                      "lat": 30.319126
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330108",
                  "name": "滨江区",
                  "center": {
                      "lng": 120.211981,
                      "lat": 30.208332
                  }
              },
              {
                  "citycode": "0571",
                  "adcode": "330109",
                  "name": "萧山区",
                  "center": {
                      "lng": 120.264263,
                      "lat": 30.184119
                  }
              }
          ]
      },
      {
          "citycode": "0572",
          "adcode": "330500",
          "name": "湖州市",
          "center": {
              "lng": 120.086881,
              "lat": 30.894178
          },
          "districtList": [
              {
                  "citycode": "0572",
                  "adcode": "330523",
                  "name": "安吉县",
                  "center": {
                      "lng": 119.680261,
                      "lat": 30.638803
                  }
              },
              {
                  "citycode": "0572",
                  "adcode": "330502",
                  "name": "吴兴区",
                  "center": {
                      "lng": 120.185608,
                      "lat": 30.857184
                  }
              },
              {
                  "citycode": "0572",
                  "adcode": "330522",
                  "name": "长兴县",
                  "center": {
                      "lng": 119.911212,
                      "lat": 31.026962
                  }
              },
              {
                  "citycode": "0572",
                  "adcode": "330503",
                  "name": "南浔区",
                  "center": {
                      "lng": 120.418244,
                      "lat": 30.850835
                  }
              },
              {
                  "citycode": "0572",
                  "adcode": "330521",
                  "name": "德清县",
                  "center": {
                      "lng": 119.9774,
                      "lat": 30.54251
                  }
              }
          ]
      },
      {
          "citycode": "0578",
          "adcode": "331100",
          "name": "丽水市",
          "center": {
              "lng": 119.923249,
              "lat": 28.467694
          },
          "districtList": [
              {
                  "citycode": "0578",
                  "adcode": "331124",
                  "name": "松阳县",
                  "center": {
                      "lng": 119.481406,
                      "lat": 28.448883
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331181",
                  "name": "龙泉市",
                  "center": {
                      "lng": 119.14126,
                      "lat": 28.074916
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331125",
                  "name": "云和县",
                  "center": {
                      "lng": 119.573454,
                      "lat": 28.116024
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331127",
                  "name": "景宁畲族自治县",
                  "center": {
                      "lng": 119.635686,
                      "lat": 27.973594
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331122",
                  "name": "缙云县",
                  "center": {
                      "lng": 120.091685,
                      "lat": 28.659294
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331121",
                  "name": "青田县",
                  "center": {
                      "lng": 120.289693,
                      "lat": 28.1396
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331102",
                  "name": "莲都区",
                  "center": {
                      "lng": 119.912266,
                      "lat": 28.4461
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331126",
                  "name": "庆元县",
                  "center": {
                      "lng": 119.062572,
                      "lat": 27.619213
                  }
              },
              {
                  "citycode": "0578",
                  "adcode": "331123",
                  "name": "遂昌县",
                  "center": {
                      "lng": 119.275865,
                      "lat": 28.592388
                  }
              }
          ]
      },
      {
          "citycode": "0570",
          "adcode": "330800",
          "name": "衢州市",
          "center": {
              "lng": 118.859307,
              "lat": 28.970229
          },
          "districtList": [
              {
                  "citycode": "0570",
                  "adcode": "330802",
                  "name": "柯城区",
                  "center": {
                      "lng": 118.874138,
                      "lat": 28.936937
                  }
              },
              {
                  "citycode": "0570",
                  "adcode": "330881",
                  "name": "江山市",
                  "center": {
                      "lng": 118.627228,
                      "lat": 28.73796
                  }
              },
              {
                  "citycode": "0570",
                  "adcode": "330822",
                  "name": "常山县",
                  "center": {
                      "lng": 118.511224,
                      "lat": 28.902446
                  }
              },
              {
                  "citycode": "0570",
                  "adcode": "330803",
                  "name": "衢江区",
                  "center": {
                      "lng": 118.959139,
                      "lat": 28.980356
                  }
              },
              {
                  "citycode": "0570",
                  "adcode": "330824",
                  "name": "开化县",
                  "center": {
                      "lng": 118.415756,
                      "lat": 29.136729
                  }
              },
              {
                  "citycode": "0570",
                  "adcode": "330825",
                  "name": "龙游县",
                  "center": {
                      "lng": 119.1723,
                      "lat": 29.028214
                  }
              }
          ]
      },
      {
          "citycode": "0575",
          "adcode": "330600",
          "name": "绍兴市",
          "center": {
              "lng": 120.582886,
              "lat": 30.051549
          },
          "districtList": [
              {
                  "citycode": "0575",
                  "adcode": "330681",
                  "name": "诸暨市",
                  "center": {
                      "lng": 120.246602,
                      "lat": 29.709398
                  }
              },
              {
                  "citycode": "0575",
                  "adcode": "330683",
                  "name": "嵊州市",
                  "center": {
                      "lng": 120.830505,
                      "lat": 29.561519
                  }
              },
              {
                  "citycode": "0575",
                  "adcode": "330624",
                  "name": "新昌县",
                  "center": {
                      "lng": 120.903918,
                      "lat": 29.500525
                  }
              },
              {
                  "citycode": "0575",
                  "adcode": "330604",
                  "name": "上虞区",
                  "center": {
                      "lng": 120.868571,
                      "lat": 30.033862
                  }
              },
              {
                  "citycode": "0575",
                  "adcode": "330602",
                  "name": "越城区",
                  "center": {
                      "lng": 120.582338,
                      "lat": 29.989092
                  }
              },
              {
                  "citycode": "0575",
                  "adcode": "330603",
                  "name": "柯桥区",
                  "center": {
                      "lng": 120.495532,
                      "lat": 30.083039
                  }
              }
          ]
      }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/zhejiang.js